import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInputClass;
function SavePairAssignmentsInput() {
  if (SavePairAssignmentsInputClass === VOID) {
    class $ {
      constructor(partyId, pairingSetId, date, pairs, discordMessageId, slackMessageId) {
        discordMessageId = discordMessageId === VOID ? Absent_getInstance() : discordMessageId;
        slackMessageId = slackMessageId === VOID ? Absent_getInstance() : slackMessageId;
        this.e6q_1 = partyId;
        this.f6q_1 = pairingSetId;
        this.g6q_1 = date;
        this.h6q_1 = pairs;
        this.i6q_1 = discordMessageId;
        this.j6q_1 = slackMessageId;
      }
      toString() {
        return 'SavePairAssignmentsInput(partyId=' + this.e6q_1.toString() + ', pairingSetId=' + this.f6q_1.toString() + ', date=' + this.g6q_1.toString() + ', pairs=' + toString(this.h6q_1) + ', discordMessageId=' + toString(this.i6q_1) + ', slackMessageId=' + toString(this.j6q_1) + ')';
      }
      hashCode() {
        var result = this.e6q_1.hashCode();
        result = imul(result, 31) + this.f6q_1.hashCode() | 0;
        result = imul(result, 31) + this.g6q_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.h6q_1) | 0;
        result = imul(result, 31) + hashCode(this.i6q_1) | 0;
        result = imul(result, 31) + hashCode(this.j6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsInput()))
          return false;
        if (!this.e6q_1.equals(other.e6q_1))
          return false;
        if (!this.f6q_1.equals(other.f6q_1))
          return false;
        if (!this.g6q_1.equals(other.g6q_1))
          return false;
        if (!equals(this.h6q_1, other.h6q_1))
          return false;
        if (!equals(this.i6q_1, other.i6q_1))
          return false;
        if (!equals(this.j6q_1, other.j6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsInput');
    SavePairAssignmentsInputClass = $;
  }
  return SavePairAssignmentsInputClass;
}
//region block: exports
export {
  SavePairAssignmentsInput as SavePairAssignmentsInput3tgrc8c2zd524,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput.mjs.map
